import { request } from './base.service';

export const deleteEntries = async (userID, listID) => {
    let url = `/entries/${userID}/${listID}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'DELETE'
    };
    return await request(url, settings);
};

export const getEntries = async (userID, listID) => {
    let url = `/entries/${userID}/${listID}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        }
    };
    return await request(url, settings);
};

export const getReports = async (userID, listID) => {
    let url = `/reports/${userID}/${listID}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'GET'
    };
    return await request(url, settings);
};

export const createReport = async (userID, listID, report) => {
    let url = `/reports/${userID}/${listID}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'POST',
        body : JSON.stringify(report)
    };
    return await request(url, settings);
};

export const updateReport = async (userID, listID, name, report) => {
    let url = `/reports/${userID}/${listID}/${name}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'PUT',
        body : JSON.stringify(report)
    };
    return await request(url, settings);
};

export const deleteReport = async (userID, listID, name) => {
    let url = `/reports/${userID}/${listID}/${name}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'DELETE'
    };
    return await request(url, settings);
};

export const getStats = async (userID, listID) => {
    let url = `/stats/${userID}/${listID}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        }
    };
    return await request(url, settings);
};

export const getUpliftEntries = async () => {
    let url = '/uplift';
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        }
    };
    return await request(url, settings);
};

export const getUpliftEntriesFor = async (userID) => {
    let url = `/uplift/${userID}`;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        }
    };
    return await request(url, settings);
};

const cleanEntries = (entries) => {
    return entries.map((entry) => {
        return {
            ...entry,
            dueDate: entry.dueDate || null,
            reminderDate: entry.reminderDate || null,
            isReminderOn: entry.isReminderOn || false,
            payments: entry.payments.filter((payment) => !payment.fromUplift)
        };
    });
};

export const saveEntry = async (userID, listID, entries) => {
    let data = {
        entries : cleanEntries(entries)
    };

    let url = `/entries/${userID}/${listID}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'PUT',
        body : JSON.stringify(data)
    };
    return await request(url, settings);
};

export const upliftEntry = async (data) => {
    let url = `/uplift` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'POST',
        body : JSON.stringify(data)
    };
    return await request(url, settings);
};

export const saveUpliftEntry = async (data) => {
    let url = `/uplift` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'PUT',
        body : JSON.stringify(data)
    };
    return await request(url, settings);
};

export const getCategorySpending = async (userID, listID, interval, date?) => {
    const params = new URLSearchParams({ userid: userID, listid: listID, interval });
    if (date) params.set('date', date);
    let url = `/entries/category-spending?${params.toString()}`;
    let settings = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return await request(url, settings);
};

export const getEoyProjections = async (userID, listID) => {
    let url = `/entries/eoy-projections?userid=${encodeURIComponent(userID)}&listid=${encodeURIComponent(listID)}`;
    let settings = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return await request(url, settings);
};

export const getCategories = async (userID) => {
    let url = `/entries/categories?userid=${encodeURIComponent(userID)}`;
    let settings = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return await request(url, settings);
};

export const getTags = async (userID) => {
    let url = `/entries/tags?userid=${encodeURIComponent(userID)}`;
    let settings = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return await request(url, settings);
};

export const getDailyProjection = async (
    userID: string,
    listID: string,
    horizonDays?: number,
    whatIfAmount?: number,
    whatIfDate?: string,
) => {
    const params = new URLSearchParams({ userid: userID, listid: listID });
    if (horizonDays != null) params.set('horizonDays', String(horizonDays));
    if (whatIfAmount != null && whatIfAmount > 0) params.set('whatIfAmount', String(whatIfAmount));
    if (whatIfDate) params.set('whatIfDate', whatIfDate);
    let url = `/entries/daily-projection?${params.toString()}`;
    let settings = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return await request(url, settings);
};

export const getTodayCash = async (userID: string, listID: string) => {
    let url = `/entries/today-cash?userid=${encodeURIComponent(userID)}&listid=${encodeURIComponent(listID)}`;
    let settings = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return await request(url, settings);
};

export const createEntry = async (userID, listID, entries) => {
    let data = {
        entries
    };

    let url = `/entries/${userID}/${listID}` ;
    let settings = {
        headers : {
            'Content-Type' : 'application/json'
        },
        method : 'POST',
        body : JSON.stringify(data)
    };
    return await request(url, settings);
};
